import React, { useEffect, useState } from "react";
import { Spin, Button, Row, Input, Space, Card, Table, Typography } from "antd";
import { ArrowRight, Medal, Search } from "lucide-react";
import { FONT } from "constants/index";
import { notificationErroInternal } from "util/api-utils";
import {  ColumnsUserBoot } from "../planning/columns-table";
import DrawerApp from "components/drawer-app";
import { getUsersBoot } from "services/boot/boot-service";
import TimelineBoot from "../managerial/managerial-timeline-boot";
import FormScorePoint from "../load-control/load-control-drawer-score-point";
import FormTrainningBoot from "./trainning-drawer-boot";

const { Text } = Typography;

const TrainningBoot = () => {
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState(null);
  const [data, setData] = useState([]);
  const [editId, setEditId] = useState(null);
  const [openDetail, setOpenDetail] = useState(false);
  const [openDetailBoot, setOpenDetailBoot] = useState(false);

  useEffect(() => {
    refreshData();
  }, []);

  function refreshData() {
    setLoading(true);
    getData();
  }

  function getData() {
    let obj = {
      search: search,
    };

    if (search == null || search == "") {
      obj = {};
    }

    getUsersBoot(obj)
      .then((res) => {
        res = res.map((obj) => ({
          ...obj,
          detail: detail,
        }));
        setLoading(false);
        setData(res);
      })
      .catch((err) => {
        setLoading(false);
        notificationErroInternal(
          "Aconteceu um erro inesperado, por favor, tente mais tarde."
        );
      });
  }

  const mountFilter = () => {
    return (
      <Row gutter={24} style={{ padding: "10px" }}>
        <Space>
          <Input
            placeholder="Pesquisar Aluno"
            onChange={(value) => setSearch(value.target.value)}
            suffix={<Search size={18} color="#e0e0e0" />}
            style={{ height: "40px" }}
            onPressEnter={refreshData}
          />

          <Button
            style={{ fontFamily: FONT }}
            type="primary"
            icon={
              <ArrowRight
                size={18}
                style={{ marginBottom: "-3px", marginRight: "7px" }}
              />
            }
            onClick={refreshData}
          >
            Filtrar
          </Button>
        </Space>
      </Row>
    );
  };

  const onCloseDetail = () => {
    setOpenDetail(false);
    refreshData();
  };
  const showDrawerDetail = () => {
    setOpenDetail(true);
  };

  function detail(row) {
    setEditId(row.id);
    showDrawerDetail();
  }
  const onCloseDetailBoot = () => {
    setOpenDetailBoot(false);
  };

  return (
    <div className="container-planning">
      <Spin size="large" spinning={loading}>
        {mountFilter()}
        <Row gutter={[24, 24]} style={{ marginLeft: "0px" }}>
          <Space
            direction="vertical"
            size={"small"}
            style={{
              flex: "1 1 ",
              minWidth: outerWidth < 501 ? "0px" : "500px",
            }}
          >
            <Card
              id="card-table"
              title={
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div style={{ flex: 1 }}>
                    <Medal
                      size={18}
                      style={{ marginBottom: "-4px", marginRight: "10px" }}
                    />
                    <Text style={{ fontSize: "15px", fontFamily: FONT }}>
                      Treino dos Alunos
                    </Text>
                  </div>
                </div>
              }
              bordered={false}
            >
              <Table
                rowKey={"id"}
                columns={ColumnsUserBoot()}
                dataSource={data}
                pagination={{ pageSize: 10, showSizeChanger: false }}
                locale={{
                  emptyText: "Sem registro",
                }}
                scroll={{ x: 500 }}
              />
            </Card>
          </Space>
        </Row>
      </Spin>

      <DrawerApp
            open={openDetailBoot}
            onClose={onCloseDetailBoot}
            title={"Ciclo de Treino"}
            body={<FormTrainningBoot />}
            width={outerWidth < 501 ? "100%" : "30%"}

            isOnlyView={true}
          />
      <DrawerApp
        open={openDetail}
        onClose={onCloseDetail}
        title={"Progresso"}
        body={<TimelineBoot user={data.find((item) => item.id == editId)} />}
        size={"large"}
        isOnlyView={true}
        width={outerWidth < 501 ? "100%" : "65%"}
        extra={
          <Button
            style={{
              fontFamily: FONT,
              background: "#14B8A6",
              color: "#ffffff",
            }}
            onClick={() => setOpenDetailBoot(true)}
          >
            Ciclo de Treino
          </Button>
        }
      />
    </div>
  );
};
export default TrainningBoot;
